<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab title="Summary" active>
                <b-card-body>
                    <b-row>
                        <b-col cols="9">
                            <b-alert
                                variant="warning"
                                show
                                class="
                                    my-2
                                    font-weight-bold
                                    py-1
                                    w-200
                                    my-0
                                    text-center
                                "
                                style="font-size: 0.9em; width: 15%"
                            >
                                {{
                                    order.type && order.type.name.toUpperCase()
                                }}
                            </b-alert>
                            <h3 class="font-weight-bold">
                                {{ order.description }}
                                <span class="text-muted"
                                    >#{{ order.reference_no }}
                                </span>
                            </h3>

                            <div class="mt-2">
                                <h5 class="font-weight-bold">
                                    Service Details
                                </h5>
                            </div>

                            <div>
                                <small class="text-muted">
                                    {{ order.category && 'Order Category' }}
                                </small>
                                <p class="font-weight-bold">
                                    {{ order.category && order.category.name }}
                                </p>
                            </div>
                            <div>
                                <small class="text-muted"> Due Date </small>
                                <h5>
                                    {{ order.schedule_at | filterDate }}
                                </h5>
                            </div>
                            <div>
                                <small class="text-muted"> Due Time </small>
                                <h5>
                                    {{ order.schedule_at | filterTime }}
                                </h5>
                            </div>
                            <div>
                                <small class="text-muted">
                                    Service Price
                                </small>
                                <h5>
                                    {{ order.items | filterPrice }}
                                </h5>
                            </div>
                            <b-row>
                                <b-col>
                                    <div class="mt-2">
                                        <h5 class="font-weight-bold">
                                            Location Details
                                        </h5>
                                    </div>
                                    <div>
                                        <small class="text-muted">
                                            Address Line 1
                                        </small>
                                        <h5>
                                            {{
                                                (order.delivery_location_section &&
                                                    order
                                                        .delivery_location_section
                                                        .location.address1) ||
                                                '-'
                                            }}
                                        </h5>
                                    </div>
                                    <div>
                                        <small class="text-muted">
                                            Address Line 2
                                        </small>
                                        <h5>
                                            {{
                                                (order.delivery_location_section &&
                                                    order
                                                        .delivery_location_section
                                                        .location.address2) ||
                                                '-'
                                            }}
                                        </h5>
                                    </div>
                                    <div>
                                        <small class="text-muted"> City </small>
                                        <h5>
                                            {{
                                                (order.delivery_location_section &&
                                                    order
                                                        .delivery_location_section
                                                        .location.city) ||
                                                '-'
                                            }}
                                        </h5>
                                    </div>
                                </b-col>
                                <b-col>
                                    <small class="text-muted">
                                        Country Code
                                    </small>
                                    <h5>
                                        {{
                                            (order.delivery_location_section &&
                                                order.delivery_location_section
                                                    .location.country_code) ||
                                            '-'
                                        }}
                                    </h5>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col variant="dark">
                            <div>
                                <small class="text-muted">
                                    Engineer Assigned
                                </small>
                                <h5>
                                    {{ order.driver | filterOfficerName }}
                                </h5>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-tab>
            <b-tab title="Messages">
                <b-card-body><ServiceNotes :order="order" /></b-card-body>
            </b-tab>
            <b-tab title="Attachments">
                <b-card-body>
                    <ServiceAttachments :order="order" />
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
//import orderHelperMixins from '@/mixins/orderHelperMixins'
//import popupMixins from '@/mixins/popupMixins'

import ServiceAttachments from './ServiceAttachments'
import ServiceNotes from './ServiceNotes'

export default {
    name: 'CustomerPortalViewService',
    components: {
        ServiceAttachments,
        ServiceNotes,
    },
    filters: {
        filterDate(date) {
            if (!date) return ''
            return date.split(' ')[0]
        },
        filterSection(section) {
            if (!section) return ''
            const { name, location } = section || {}
            const { address1, address2, city } = location || {}
            return `${name}<br/>${address1}<br/>${address2}<br/>${city}`
        },
        filterTime(date) {
            if (!date) return ''
            return date.split(' ')[1]
        },
        filterOfficerName(officer) {
            if (!officer) return ''
            return officer.first_name + ' ' + officer.last_name
        },
        filterPrice(items) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            const sum = (items || []).reduce((sum, item) => {
                sum +=
                    parseFloat(item.quantity) *
                    parseFloat(item.price) *
                    (1 + parseFloat(item.tax_rate) / 100)
                return sum
            }, 0)
            if (!sum) return '-'
            return formatter.format(sum)
        },
    },
    computed: {
        order() {
            console.log('Order is: ')
            const computedOrder =
                this.$store.state.customerPortal.selectedOrder || {}
            console.log(computedOrder)
            return computedOrder
        },
    },
    watch: {},
    mounted() {
        this.$store.dispatch('customerPortal/fetchOrder', this.$route.params.id)
    },
    methods: {},
}
</script>
<style></style>
